import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "narrow-view" }
const _hoisted_2 = { class: "view-full-span" }
const _hoisted_3 = { class: "view-full-span" }

import LoginForm from '@/components/forms/LoginForm'

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('general.greeting', { name: _ctx.$t('general.bowler') })), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('general.login-description')), 1),
    _createVNode(_unref(LoginForm))
  ]))
}
}

})